"use strict";

/* ------------------------------------------------------------------ *
 * Mapper 29: RET-CUFROM (homebrew / RET circuit)
 * ------------------------------------------------------------------ */
function register(Mappers) {
  Mappers[29] = function (nes) {
    this.nes = nes;
  };

  Mappers[29].prototype = new Mappers[0]();

  Mappers[29].prototype.irqClockRate = "none";

  Mappers[29].prototype.reset = function () {
    Mappers[0].prototype.reset.apply(this);
    this.prgBank = 0;
    this.mirroring = this.nes.rom.mirroring || 0;
  };

  Mappers[29].prototype.write = function (address, value) {
    if (address >= 0x8000) {
      this.prgBank = value & 0x0f;
      this.loadRomBank(this.prgBank, 0x8000);
      if (this.nes.rom.chrSize > 0) {
        var num8k = this.nes.rom.header[5];
        if (num8k && num8k > 0) {
          var chrBank = (value >> 4) & 0x0f;
          chrBank = Math.min(chrBank, Math.min(num8k, 16) - 1);
          this.load8kVromBank(chrBank * 2, 0x0000);
        }
      }
    } else {
      Mappers[0].prototype.write.apply(this, arguments);
    }
  };

  Mappers[29].prototype.loadROM = function () {
    if (!this.nes.rom.valid) {
      throw new Error("RET-CUFROM: Invalid ROM! Unable to load.");
    }
    this.reset();
    this.loadCHRROM();
    this.loadBatteryRam();
    this.loadTrainer();
    this.loadRomBank(0, 0x8000);
    this.loadRomBank(this.nes.rom.romCount - 1, 0xc000);
    this.nes.cpu.requestIrq(this.nes.cpu.IRQ_RESET);
  };
}

module.exports = { register: register };
